import {
  CoveragePlanCard,
  CoveragePlanCardUrl,
  CoveragePlanStatus,
  CoveragePlanType,
  Language
} from '@cms-max/medicare-api-sdk'
import { rest } from 'msw'
import { isTest } from 'test-utils/isTest'
import { coreApiBase } from './coreApiBase'

const urlEn: CoveragePlanCardUrl = {
  language: Language.En,
  url: 'https://medicare.gov/url-en'
}
const urlEs: CoveragePlanCardUrl = {
  language: Language.Es,
  url: 'https://medicare.gov/url-es'
}

export const planMap: { [key: string]: CoveragePlanCard } = {
  partA: {
    pbp_id: 'om-parta',
    contract_id: 'parta-123',
    type: CoveragePlanType.OmPartA,
    title: 'Original Medicare',
    name: 'Hospital Insurance (Part A)',
    active: true,
    enrollment_effective_date: '2019-08-12',
    contract_effective_date: '2019-08-12',
    disenrollment_date: '',
    status: CoveragePlanStatus.Current,
    urls: [urlEn, urlEs]
  },
  partB: {
    pbp_id: 'om-partb',
    contract_id: 'partb-123',
    type: CoveragePlanType.OmPartB,
    title: 'Original Medicare',
    name: 'Medical Insurance (Part B)',
    active: true,
    enrollment_effective_date: '2019-08-12',
    contract_effective_date: '2019-08-12',
    disenrollment_date: '',
    status: CoveragePlanStatus.Current,
    urls: [urlEn, urlEs]
  },
  ma: {
    pbp_id: 'ma',
    contract_id: 'ma-123',
    type: CoveragePlanType.Ma,
    title: 'Medicare Advantage Plan',
    name: 'Alterwood Advantage Select (HMO)',
    active: true,
    enrollment_effective_date: '2016-05-01',
    contract_effective_date: '2016-05-01',
    disenrollment_date: '',
    status: CoveragePlanStatus.Current,
    urls: [urlEn, urlEs]
  },
  mapd: {
    pbp_id: 'mapd',
    contract_id: 'mapd-123',
    type: CoveragePlanType.Mapd,
    title: 'Medicare Advantage Plan',
    name: 'Alterwood Advantage Select (HMO)',
    active: true,
    enrollment_effective_date: '2016-05-01',
    contract_effective_date: '2016-05-01',
    disenrollment_date: '',
    status: CoveragePlanStatus.Current,
    urls: [urlEn, urlEs],
    rxCard: {
      name: 'Alterwood Advantage Select (HMO)',
      groupNumber: '354544',
      bin: '610502',
      id: 'MEBDRZQB',
      pcn: '00670000',
      startDate: '2016-05-01',
      endDate: ''
    }
  },
  partD: {
    pbp_id: 'pdp',
    contract_id: 'pdp-123',
    type: CoveragePlanType.Pdp,
    title: 'Drug Insurance (Part D)',
    name: 'Elixir RxSecure (PDP)',
    active: true,
    enrollment_effective_date: '2022-01-01',
    contract_effective_date: '2022-01-01',
    disenrollment_date: '',
    status: CoveragePlanStatus.Current,
    urls: [urlEn, urlEs]
  },
  pbid: {
    pbp_id: 'pbid',
    contract_id: 'pbid-123',
    type: CoveragePlanType.Pbid,
    title: 'Immunosuppressive drugs (Part B)',
    name: 'Immuno Drug Only',
    active: true,
    enrollment_effective_date: '2022-01-01',
    contract_effective_date: '2022-01-01',
    disenrollment_date: '',
    status: CoveragePlanStatus.Current,
    urls: [urlEn, urlEs]
  },
  other: {
    pbp_id: 'other',
    contract_id: 'other-123',
    type: CoveragePlanType.Pdp,
    title: 'Other Insurance',
    name: 'Aetna Retiree Plan',
    active: true,
    enrollment_effective_date: '2012-02-01',
    contract_effective_date: '2022-02-01',
    disenrollment_date: '',
    status: CoveragePlanStatus.Current,
    urls: [urlEn, urlEs]
  },
  pastPartA: {
    pbp_id: 'om-parta-past',
    contract_id: 'parta-past-123',
    type: CoveragePlanType.OmPartA,
    title: 'Original Medicare',
    name: 'Hospital Insurance (Part A)',
    active: true,
    enrollment_effective_date: '2019-08-12',
    contract_effective_date: '2019-08-12',
    disenrollment_date: '2021-12-31',
    status: CoveragePlanStatus.Past,
    urls: [urlEn, urlEs]
  },
  pastPartB: {
    pbp_id: 'om-partb-past',
    contract_id: 'partb-past-123',
    type: CoveragePlanType.OmPartB,
    title: 'Original Medicare',
    name: 'Medical Insurance (Part B)',
    active: true,
    enrollment_effective_date: '2019-08-12',
    contract_effective_date: '2019-08-12',
    disenrollment_date: '2021-12-31',
    status: CoveragePlanStatus.Past,
    urls: [urlEn, urlEs]
  },
  pastMa: {
    pbp_id: 'ma-past',
    contract_id: 'ma-past-123',
    type: CoveragePlanType.Ma,
    title: 'Medicare Advantage Plan',
    name: 'Alterwood Advantage Select (HMO)',
    active: true,
    enrollment_effective_date: '2016-05-01',
    contract_effective_date: '2016-05-01',
    disenrollment_date: '2017-12-31',
    status: CoveragePlanStatus.Past,
    urls: [urlEn, urlEs]
  },
  futurePartA: {
    pbp_id: 'om-parta',
    contract_id: 'parta-123',
    type: CoveragePlanType.OmPartA,
    title: 'Original Medicare',
    name: 'Hospital Insurance (Part A)',
    active: true,
    enrollment_effective_date: '2024-08-12',
    contract_effective_date: '2024-08-12',
    disenrollment_date: '',
    status: CoveragePlanStatus.Future,
    urls: [urlEn, urlEs]
  },
  futurePartB: {
    pbp_id: 'om-partb',
    contract_id: 'partb-123',
    type: CoveragePlanType.OmPartB,
    title: 'Original Medicare',
    name: 'Medical Insurance (Part B)',
    active: true,
    enrollment_effective_date: '2024-08-12',
    contract_effective_date: '2024-08-12',
    disenrollment_date: '',
    status: CoveragePlanStatus.Future,
    urls: [urlEn, urlEs]
  },
  futureMa: {
    pbp_id: 'ma-past',
    contract_id: 'ma-past-123',
    type: CoveragePlanType.Ma,
    title: 'Medicare Advantage Plan',
    name: 'Alterwood Advantage Select (HMO)',
    active: true,
    enrollment_effective_date: '2024-01-01',
    contract_effective_date: '2024-01-01',
    disenrollment_date: '',
    status: CoveragePlanStatus.Future,
    urls: [urlEn, urlEs]
  },
  futureMapd: {
    pbp_id: 'mapd',
    contract_id: 'mapd-123',
    type: CoveragePlanType.Mapd,
    title: 'Medicare Advantage Plan',
    name: 'Alterwood Advantage Select (HMO)',
    active: true,
    enrollment_effective_date: '2024-05-01',
    contract_effective_date: '2024-05-01',
    disenrollment_date: '',
    status: CoveragePlanStatus.Future,
    urls: [urlEn, urlEs],
    rxCard: {
      name: 'Alterwood Advantage Select 2024 (HMO)',
      groupNumber: '354544',
      bin: '610502',
      id: 'MEBDRZQB',
      pcn: '00670000',
      startDate: '2024-05-01',
      endDate: ''
    }
  }
}

export function plansSuccess (items: Array<keyof typeof planMap> = []) {
  return rest.get(`${coreApiBase}/plans`, (req, res, ctx) => {
    return res(
      ctx.delay(isTest ? 0 : undefined),
      ctx.status(200),
      ctx.json({
        plans: items.map((item) => planMap[item])
      })
    )
  })
}

type plansLoadingOpts = {
  items?: Array<keyof typeof planMap>
  ttl?: number
}
export function plansLoading (opts?: plansLoadingOpts) {
  const { items = [], ttl = 10000 } = opts || {}

  return rest.get(`${coreApiBase}/plans`, (req, res, ctx) => {
    return res(
      ctx.delay(ttl),
      ctx.status(200),
      ctx.json({
        plans: items.map((item) => planMap[item])
      })
    )
  })
}

export function plansError () {
  return rest.get(`${coreApiBase}/plans`, (req, res, ctx) => {
    return res(ctx.delay(isTest ? 0 : undefined), ctx.status(500), ctx.json({}))
  })
}
